import React, { useCallback, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs, { Dayjs } from "dayjs";
import {
  ArrowForward as ArrowForwardIcon,
  CloudDownload as CloudDownloadIcon,
} from "@mui/icons-material";
import { CardPageHeader, DatePicker } from "ctech-react-components";
import manHistoryOrders from "assets/supergasbras/images/manHistoryOrders.svg";
import { handleGetDownloadXlsRequest } from "store/modules/Report/thunk.store";
import { useAppDispatch } from "store/hooks";
import { useAuth } from "context/AuthContext";
import { format } from "date-fns";
import * as Styled from "./styles";

const ReportsOrderHistory = () => {
  const { t } = useTranslation();
  const [from, setFrom] = useState<Dayjs | null | any>(dayjs(new Date()));
  const [to, setTo] = useState<Dayjs | null | any>(dayjs(new Date()));

  const dispatch = useAppDispatch();

  const { dealerId } = useAuth();

  const handleReport = useCallback(() => {
    dispatch(
      handleGetDownloadXlsRequest({
        dealerId,
        dateFrom: format(new Date(from || Date()), "yyyy-MM-dd"),
        dateTo: format(new Date(to || Date()), "yyyy-MM-dd"),
      }),
    ).unwrap();
  }, [dealerId, dispatch, from, to]);

  return (
    <Styled.Container>
      <Styled.Content>
        <CardPageHeader
          urlImage={manHistoryOrders}
          title={<Typography variant="h5">{t("orderHistory")}</Typography>}
        />
        <Styled.Box>
          <Grid
            container
            columns={12}
            spacing={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Grid
              item
              xs={6}
              md={8}
              sm={12}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <DatePicker
                label="De"
                value={from}
                handleChange={setFrom}
                fullWidth
                disabledInput
              />
              <ArrowForwardIcon sx={{ marginLeft: 1, marginRight: 1 }} />
              <DatePicker
                label="Até"
                value={to}
                handleChange={setTo}
                minDate={dayjs(from)}
                maxDate={dayjs(from).add(59, "day")}
                fullWidth
                disabledInput
              />
            </Grid>
            <Grid
              item
              xs={6}
              md={8}
              sm={12}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Button
                variant="outlined"
                fullWidth
                size="large"
                onClick={() => handleReport()}
                sx={{ borderRadius: 8, marginTop: 2 }}
                endIcon={<CloudDownloadIcon />}
              >
                {t("downloadOrderReportInFormat")} .EXCEL
              </Button>
            </Grid>
          </Grid>
        </Styled.Box>
      </Styled.Content>
    </Styled.Container>
  );
};

export default ReportsOrderHistory;
